import { SitesTableObject } from './sites-table/sites-object.model';
import { ContactObject } from './sites-table/sites-contacts-table/contact-object.model';
import { AddressesObject } from './sites-table/sites-address-table/addresses-object.model';
import { isNullOrUndefined } from 'util';
import { CharacteristicObject } from '../../characteristics/characteristic/characteristic-object.model';

export class SitesObject {

    constructor(private table: SitesTableObject, private contacts: Array<ContactObject>,
        private addresses: Array<AddressesObject>) {
    }

    public static create() {
        return new SitesObject(SitesTableObject.create(), new Array<ContactObject>(), new Array<AddressesObject>());
    }

    public getSitesTable(): SitesTableObject {
        return this.table;
    }

    public getContacts(): Array<ContactObject> {
        return this.contacts;
    }

    public getAddresses(): Array<AddressesObject> {
        return this.addresses;
    }

    public getAddressesByFormat(format: string): Array<CharacteristicObject> {
        for (const addressesElement of this.addresses) {
            if (addressesElement.getFormat() === format) {
                return addressesElement.getAddresses().getAllCharacteristics();
            }
        }
        return new Array<CharacteristicObject>();
    }

    public getAllFormats(): Array<string> {
        const allFormats = new Array<string>();
        if (!isNullOrUndefined(this.addresses)) {
            for (const address of this.addresses) {
                allFormats.push(address.getFormat());
            }
        }
        return allFormats;
    }
}